import type { Context } from './context'
import { Node } from './node'

/**
 * Identifies a {@link Node}
 */
export type Id = string
export namespace Id {
  /**
   * Identifies the root {@link Node} in a query graph
   */
  export const FOR_ROOT: Id = 'root'

  export function from(identifier: Identifiable): Id {
    return identifier instanceof Node ? identifier.id : identifier
  }

  /**
   * Creates an {@link Id} for a new {@link Node}
   */
  export function create({
    name = FOR_ROOT,
    parentInfo,
  }: Readonly.Deep<Pick<Context, 'name' | 'parentInfo'>>): string {
    return parentInfo ? [parentInfo.id, name].join('/') : name
  }
}

/**
 * Can be used to get an {@link Id}
 *
 * @see {@link Id.from}
 */
export type Identifiable = Node | Id
